module.exports = __webpack_public_path__ + "img/indd.0297e59.svg";